import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";

const columnHelper = createColumnHelper<any>();

const getEquipmentActivityLogColumns = () => [
  columnHelper.accessor("changedAt", {
    id: "changedAt",
    header: "Timestamp",
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const date = new Date(value);
      const formattedParts = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      const formattedDate = date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
      });

      return (
        <div>
          <span>{formattedDate} </span>
          <span className="xgs-activitylog__formatedtime">{formattedParts}</span>
        </div>
      );
    },
    enableColumnFilter: false,
    size: 170,
  }),
  columnHelper.accessor("equipment", {
    id: "equipment",
    header: "Unit Number",
    enableColumnFilter: false,
    size: 120,
    minSize: 90,
  }),
  columnHelper.accessor("equipmentType", {
    id: "equipmentType",
    header: "Type",
    enableColumnFilter: false,
    size: 120,
    minSize: 90,
  }),
  columnHelper.accessor("action", {
    id: "action",
    header: "Action",
    cell: (cellProps) => {
      const rawAction = cellProps.row.original?.action;
      const action = String(rawAction ?? "").toUpperCase();
      const actionColorMap: Record<string, TagColor> = {
        UPDATE: TagColor.ORANGE,
        CREATE: TagColor.GREEN,
        APPROVE: TagColor.GREEN,
        DELETE: TagColor.RED,
        DEACTIVATE: TagColor.RED,
        REJECT: TagColor.RED,
      };
      const actionLabels: Record<string, string> = {
        CREATE: "Create",
        UPDATE: "Update",
        DELETE: "Deactivate",
        DEACTIVATE: "Deactivate",
      };
      const tagColor = actionColorMap[action] || TagColor.GREY;
      const label = actionLabels[action] || rawAction;
      return (
        <div className="xgs-equipment-activitylog__action-cell">
          <Tag mods={{ color: tagColor }}>{label}</Tag>
        </div>
      );
    },
    enableColumnFilter: false,
    size: 115,
    minSize: 100,
  }),
  columnHelper.accessor("modifiedBy", {
    id: "modifiedBy",
    header: "Changed By",
    enableColumnFilter: false,
    size: 170,
  }),
  columnHelper.accessor("changeDescription", {
    id: "changeDescription",
    header: "Description",
    enableColumnFilter: false,
    size: 270,
  }),
];

export default getEquipmentActivityLogColumns;
